const MaterialLibrary = () => import('@/views/main/promotion/materialLibrary/MaterialLibrary.vue')
export default {
  path: '/main/promotion/materialLibrary',
  name: 'MaterialLibrary',
  component: MaterialLibrary,
  children: []
}
